const nav = document.querySelector(".header__icon-wrapper")

// handle overriding search drawers for Algolia integration 
const searchDrawerTargetNode = document.querySelector(".search-modal__form");
const search = document.querySelector('.header__search-bar')
const bodyTargetNode = document.body
const navBarSearchButton = document.querySelector(".js-search-mobile");

const targetedElements = document.querySelectorAll('[id^="expanded-"]');

let eventRunning = false;


function isDesktop() {
    return window.innerWidth > 1024;
}

function toggleNav({ target }) {
    const expanded = nav.getAttribute('aria-expanded') === 'true';
    const isOpen = document.getElementById('mobile-menu-drawer').open;

    nav.setAttribute('aria-expanded', !expanded)
    document.getElementById('mobile-menu-drawer').open = !isOpen;
}

function updateChatButtonPositions(isOpening) {
    if (eventRunning) return;

    eventRunning = true; // Prevent multiple executions

    // this could change
    const chatButton = document.getElementById('gorgias-chat-container').querySelector('#chat-button');
    const chatButton2 = document.querySelector('.R-LauncherButton');

    const computedStyle2 = getComputedStyle(chatButton2);
    const top = parseFloat(computedStyle2.getPropertyValue('top')) || 0;
    const bottom = parseFloat(computedStyle2.getPropertyValue('bottom')) || 0;

    // Adjust positions based on the opening/closing state
    const chatButton2TopAdjustment = isOpening ? -60 : 60;
    const chatButton2BottomAdjustment = isOpening ? 60 : -60;

    // Adjust the bottom position of the chat button
    chatButton.style.bottom = isOpening ? "80px" : "20px";

    chatButton2.style.top = isOpening ? `${top + chatButton2TopAdjustment}px` : 'auto';
    chatButton2.style.bottom = `${bottom + chatButton2BottomAdjustment}px`;

    // Allow the next event to run immediately after
    setTimeout(() => {
        eventRunning = false;
    }, 0);
}

window.addEventListener("DOMContentLoaded", (event) => {

    document.querySelectorAll('.price-match').forEach(element => {
        element.addEventListener('click', function () {
            const clickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true
            });

            const target = document.querySelector('.floating-button');
            const productName = this.dataset.name;
            const sku = this.dataset.sku;
            const variantName = this.dataset.variant;
            const email = this.dataset.email;


            const productNameSelector = document.querySelector('.product-name input');
            const skuSelector = document.querySelector('.sku input');
            const emailSelector = document.querySelector('.form-email input');

            if (productNameSelector && skuSelector) {
                productNameSelector.value = productName + " " + variantName;
                skuSelector.value = sku;

                if(email){
                    emailSelector.value = email
                }

                // productNameSelector.focus();
                // skuSelector.focus();
            }

            // Dispatch the click event on the floating button
            if (target) {
                target.dispatchEvent(clickEvent);
            }
        });
    });

    document.querySelectorAll('.variant-image-btn').forEach(x => {
        x.addEventListener('click', function () {
            x.dataset.test = true;
            const zoomElement = document.querySelector('product-image-zoom');
            zoomElement.setAttribute('open', 'true');
        });
    })

    // nav 
    if (!isDesktop()) {
        document.addEventListener('mobile-nav:open', () => updateChatButtonPositions(true));
        document.addEventListener('mobile-nav:close', () => updateChatButtonPositions(false));
    }


    targetedElements.forEach(element => {
        element.addEventListener("change", function () {
            var labelSpan = this.parentElement.querySelector(".btn");

            if (this.checked) {
                labelSpan.textContent = "Say Less...";
            } else {
                labelSpan.textContent = "Read More...";
            }
        });
    });
})

if (isDesktop()) {
    const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const aaPanelElement = document.querySelector('.aa-Panel');
                if (aaPanelElement) {
                    document.documentElement.classList.add("lock-all");
                } else {
                    document.documentElement.classList.remove("lock-all");
                }
            }
        }
    };

    // Options for the observer (which mutations to observe)
    const config = { childList: true, subtree: true };

    // Create an observer instance linked to the callback function
    const Desktopobserver = new MutationObserver(callback);

    // Assuming bodyTargetNode is already defined somewhere in your script
    Desktopobserver.observe(bodyTargetNode, config);
} else {

    const searchDrawerCallback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList") {
                navBarSearchButton.addEventListener('click',
                    function () {
                        const skipSearchOpenButton = document.querySelector(".aa-DetachedSearchButton");
                        if (skipSearchOpenButton) {
                            skipSearchOpenButton.click();
                        }
                        const bodyObserver = new MutationObserver(bodyCallback);
                        bodyObserver.observe(bodyTargetNode, { childList: true });
                    });
            }
        }
    };

    const bodyCallback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList") {
                const inputToFocus = document.getElementById("autocomplete-0-input");
                if (inputToFocus !== null) {
                    inputToFocus.focus(); // note: this is disabled by IOS
                }
                const cancelSearchButton = document.querySelector(".aa-DetachedCancelButton");
                const skipSearchCloseButton = document.querySelector(".btn--link.search-bar__close.js-drawer-close");
                if (cancelSearchButton !== null) {
                    cancelSearchButton.addEventListener('click',
                        function () {
                            skipSearchCloseButton.click();
                        });
                }
            }
        }
    }
    const searchDrawerObserver = new MutationObserver(searchDrawerCallback);
    searchDrawerObserver.observe(searchDrawerTargetNode, { childList: true });
}
